import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { SavedBy } from "@/admin/Recorded";
import { Pill, Table } from "@/admin/AdminLayout";

export function MemorialInbox({ onCount }: { onCount?: (n: number) => void }) {
  const [d, setD] = useState<any>(null);
  const [tab, setTab] = useState("enquiries");
  const load = () => api.get("/admin-x/memorial").then((r) => { setD(r.data); onCount?.(r.data.stories.filter((s: any) => s.status === "pending").length); });
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const act = async (fn: () => Promise<any>) => { try { await fn(); load(); } catch (e) { toast.error(errMsg(e)); } };
  if (!d) return null;
  return (
    <div data-testid="memorial-inbox">
      <div className="flex gap-5 mb-4 text-xs">
        {[["enquiries", `Enquiries (${d.enquiries.length})`], ["stories", `Family stories (${d.stories.filter((s: any) => s.status === "pending").length} to review)`]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} className={`pb-1 border-b ${tab === k ? "border-neutral-900" : "border-transparent text-neutral-500"}`} data-testid={`memorial-tab-${k}`}>{l}</button>
        ))}
      </div>
      {tab === "enquiries" ? (
        <Table head={["Received", "Contact", "For", "Considering", "Preferences", "Message", "Status"]} testId="memorial-enquiries-table">
          {d.enquiries.map((e: any) => (
            <tr key={e.id}>
              <td className="px-4 py-3 text-xs">{new Date(e.created_at).toLocaleString("en-AU")}</td>
              <td className="px-4 py-3">{e.name}<div className="text-xs"><a href={`mailto:${e.email}`} className="underline">{e.email}</a></div><div className="text-xs">{e.phone} {e.contact_pref && `· prefers ${e.contact_pref}`}</div></td>
              <td className="px-4 py-3 text-xs">{e.for_whom === "pet" ? "Pet" : "Loved one"}{e.loved_one && <div>{e.loved_one}</div>}</td>
              <td className="px-4 py-3 text-xs">{e.considering}</td>
              <td className="px-4 py-3 text-xs">{[e.color, e.size, e.setting].filter(Boolean).join(" · ") || "—"}</td>
              <td className="px-4 py-3 text-xs max-w-xs">{e.message}</td>
              <td className="px-4 py-3"><select value={e.status} onChange={(x) => act(() => api.put(`/admin-x/memorial/enquiries/${e.id}`, { status: x.target.value }))} className="border border-neutral-300 text-xs px-2 py-1" data-testid={`memorial-enquiry-status-${e.id}`}>
                {[["new", "New"], ["contacted", "Contacted"], ["in_progress", "In progress"], ["closed", "Closed"]].map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select><SavedBy d={e} testId={`memorial-enquiry-saved-${e.id}`} /></td>
            </tr>
          ))}
        </Table>
      ) : (
        <Table head={["Submitted", "From", "Story", "Status", ""]} testId="memorial-stories-table">
          {d.stories.map((s: any) => (
            <tr key={s.id}>
              <td className="px-4 py-3 text-xs">{new Date(s.created_at).toLocaleDateString("en-AU")}</td>
              <td className="px-4 py-3 text-xs">{s.name}<div>{s.location}</div>{s.honoring && <div className="text-neutral-500">In memory of {s.honoring}</div>}<div>{"★".repeat(s.rating || 5)}</div></td>
              <td className="px-4 py-3 text-xs max-w-md">{s.story}</td>
              <td className="px-4 py-3"><Pill tone={s.status === "approved" ? "green" : s.status === "pending" ? "amber" : "neutral"}>{s.status}</Pill><SavedBy d={s} testId={`memorial-story-saved-${s.id}`} /></td>
              <td className="px-4 py-3 whitespace-nowrap space-x-3 text-xs">
                {s.status !== "approved" && <button onClick={() => act(() => api.put(`/admin-x/memorial/stories/${s.id}`, { status: "approved" }))} className="underline" data-testid={`story-approve-${s.id}`}>Approve</button>}
                {s.status !== "rejected" && <button onClick={() => act(() => api.put(`/admin-x/memorial/stories/${s.id}`, { status: "rejected" }))} className="underline" data-testid={`story-hide-${s.id}`}>{s.status === "approved" ? "Hide" : "Reject"}</button>}
                <button onClick={() => window.confirm("Delete this story?") && act(() => api.delete(`/admin-x/memorial/stories/${s.id}`))} className="underline text-red-800" data-testid={`story-delete-${s.id}`}>Delete</button>
              </td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
